module.exports = __webpack_public_path__ + "media/images/icons/star-7db3e2fbe2c48ada6e5ddf7118b539fb.svg";